import { forwardRef, useCallback } from 'react';

import { BaseComponent } from '../BaseComponent.tsx';
import type { IconFilledProps, IconRender } from '../types.ts';

const PersonAdd = forwardRef<SVGSVGElement | null, IconFilledProps>(function PersonAdd({ filled, dataTestId, ...props }, ref) {
  // eslint-disable-next-line no-restricted-syntax
  const iconRender = useCallback<IconRender>(
    (color: string) => (
      <>
        {/* default */}
        <path
          d='M4.75 9C4.47386 9 4.25 8.77614 4.25 8.5V6.75H2.5C2.22386 6.75 2 6.52614 2 6.25V5.75C2 5.47386 2.22386 5.25 2.5 5.25H4.25V3.5C4.25 3.22386 4.47386 3 4.75 3H5.25C5.52614 3 5.75 3.22386 5.75 3.5V5.25H7.5C7.77614 5.25 8 5.47386 8 5.75V6.25C8 6.52614 7.77614 6.75 7.5 6.75H5.75V8.5C5.75 8.77614 5.52614 9 5.25 9H4.75Z'
          fill={filled ? 'transparent' : color}
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M13 12C15.2091 12 17 10.2091 17 8C17 5.79086 15.2091 4 13 4C10.7909 4 9 5.79086 9 8C9 10.2091 10.7909 12 13 12ZM13 10.5C14.3807 10.5 15.5 9.38071 15.5 8C15.5 6.61929 14.3807 5.5 13 5.5C11.6193 5.5 10.5 6.61929 10.5 8C10.5 9.38071 11.6193 10.5 13 10.5Z'
          fill={filled ? 'transparent' : color}
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M20.9579 15.7065C21.2992 15.97 21.5 16.3835 21.5 16.8226V18.75C21.5 19.3023 21.0523 19.75 20.5 19.75H5.5C4.94772 19.75 4.5 19.3023 4.5 18.75V16.8226C4.5 16.3835 4.70085 15.97 5.04212 15.7065C9.7579 12.0656 16.2421 12.0656 20.9579 15.7065ZM5.95714 16.8752V18.25H20.0429V16.8752C15.8622 13.6761 10.1378 13.6761 5.95714 16.8752Z'
          fill={filled ? 'transparent' : color}
        />
        {/* filled */}
        <path
          d='M4.75 9C4.47386 9 4.25 8.77614 4.25 8.5V6.75H2.5C2.22386 6.75 2 6.52614 2 6.25V5.75C2 5.47386 2.22386 5.25 2.5 5.25H4.25V3.5C4.25 3.22386 4.47386 3 4.75 3H5.25C5.52614 3 5.75 3.22386 5.75 3.5V5.25H7.5C7.77614 5.25 8 5.47386 8 5.75V6.25C8 6.52614 7.77614 6.75 7.5 6.75H5.75V8.5C5.75 8.77614 5.52614 9 5.25 9H4.75Z'
          fill={filled ? color : 'transparent'}
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M13 12C15.2091 12 17 10.2091 17 8C17 5.79086 15.2091 4 13 4C10.7909 4 9 5.79086 9 8C9 10.2091 10.7909 12 13 12Z'
          fill={filled ? color : 'transparent'}
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M20.9579 15.7065C21.2992 15.97 21.5 16.3835 21.5 16.8226V18.75C21.5 19.3023 21.0523 19.75 20.5 19.75H5.5C4.94772 19.75 4.5 19.3023 4.5 18.75V16.8226C4.5 16.3835 4.70085 15.97 5.04212 15.7065C9.7579 12.0656 16.2421 12.0656 20.9579 15.7065Z'
          fill={filled ? color : 'transparent'}
        />
      </>
    ),
    [filled],
  );
  return <BaseComponent ref={ref} dataTestId={dataTestId ?? 'person-add-icon-svg'} iconRender={iconRender} {...props} />;
});

export default PersonAdd;
